import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string[];
  ogImage?: string;
  ogType?: 'website' | 'article' | 'profile';
  canonicalUrl?: string;
}

export const SEO: React.FC<SEOProps> = ({
  title,
  description = "Nossa Pesca.com - A maior plataforma de turismo de pesca do Brasil. Pousadas, guias e experiências inesquecíveis.",
  keywords = ["pesca esportiva", "turismo de pesca", "pousadas de pesca", "guias de pesca", "araguaia", "pantanal"],
  ogImage = "https://nossapesca.com/og-default.jpg",
  ogType = 'website',
  canonicalUrl
}) => {
  const siteTitle = title ? `${title} | Nossa Pesca` : "Nossa Pesca.com - Turismo de Pesca";
  const finalCanonicalUrl = canonicalUrl || window.location.href;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{siteTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords.join(', ')} />
      <link rel="canonical" href={finalCanonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={finalCanonicalUrl} />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={finalCanonicalUrl} />
      <meta property="twitter:title" content={siteTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />
    </Helmet>
  );
};
